import { useMemo } from 'react'

import OrganizationSettingTable from '@/components/organization/cards/OrganizationSettingTable'
import Card from '@/components/shared/Card'
import { useAppStore } from '@/store/useAppStore'
import buildOrgPath from '@/utils/orgRoute'
import trpc from '@/utils/trpc'

interface Props {
  disabled: boolean
}

const OrganizationMedicalInfoCard = ({ disabled }: Props) => {
  const currentOrganization = useAppStore.use.currentOrganization().organization

  const medicalInfoQuery = trpc.medicalInfo.list.useQuery(
    {
      organizationId: currentOrganization?.id || '',
    },
    {
      enabled: !!currentOrganization,
    }
  )

  const mappedData = useMemo(() => {
    return (
      medicalInfoQuery.data?.map((medicalInfo) => ({
        id: medicalInfo.id,
        name: medicalInfo.type,
        species: medicalInfo.species || '',
        minAgeWeeks: medicalInfo.minAgeWeeks,
      })) || []
    )
  }, [medicalInfoQuery.data])

  return (
    <Card title="Medical Info">
      <OrganizationSettingTable
        addButtonTestID="add-medical-info-button"
        data={mappedData}
        disabled={disabled}
        editRoute={buildOrgPath(`/org-settings/${currentOrganization?.id}/medical-info`)}
      />
    </Card>
  )
}

export default OrganizationMedicalInfoCard
